// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1OHtZ","choiceBoxes":"toolbarselects_choiceBoxes__1qmNl","simpleField":"toolbarselects_simpleField__1P9VD"};